import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { CountdownLoader } from 'containers/Notifications/CountdownLoader';
import renderIcon from 'helpers/renderIcon';
require('./style.css');

interface IProps {
	/* functions props */
	t?: (key: string) => string;
	onStartExploringClick: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class Completed extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t } = this.props;

		return (
			<div className="getStarted">
				<div className="imageGetStarted">{renderIcon('symbol2')}</div>
				<h2 dangerouslySetInnerHTML={{ __html: t('OnboardingQuiz_Completed_Title') }} />
				<p>{t('OnboardingQuiz_Completed_Desc')}</p>
				<CountdownLoader timeoutMs={3000} onFinished={() => this.props.onStartExploringClick()} />
			</div>
		);
	}
}

export { Completed };
